/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

export const environment = {
  env: "staging",
  production: true,
  backend: "https://app-staging.storydoc.com/api",
  stories: "https://www-staging.storydoc.com",
  storiesOld: "https://www-staging.storydoc.com",
  assets: "https://assets-staging.storydoc.com",
  mixpanel: "97d8ed158b18e01de0155b8eb903b7f3",
  blankTemplateId: "617fdf56541e2859725b4f0c",
  editorV4BlankTemplateId: "634d723d62b94f000a5c88c0",
  sealComponentId: "6371f2d5a316be000a42d29a",
  latestStoriesOrgId: "1ec550de0cfcfc61503d746d13a28083",
  emailValidationEndpoint: "https://website-t577tuu5xq-ew.a.run.app/validate",
  files: "storydoc-files-staging",
  oktaAppId: "0oa4hp85crSg96e4I5d6",
  turnstileSiteKey: "0x4AAAAAAAL4-LuW6xeAOp_E",
  firebaseConfig: {
    apiKey: "AIzaSyDkAQdusdq_4YdSCEqB2RxivpEvM4Qa4ZA",
    authDomain: "platform-staging-303007.firebaseapp.com",
    projectId: "platform-staging-303007",
  },
  earlyBirds: {
    testingGroupA: {
      coupon: "earlyBird2024-2",
      percentageDiscount: 60,
      periodInMinutes: 48 * 60,
    },
    testingGroupB: {
      coupon: "earlyBird2024-2",
      percentageDiscount: 60,
      periodInMinutes: 48 * 60,
    },
  },
  paddle: {
    vendorId: 2373,
    designerAdviceProductId: 12537,
    additionalSeatsSubsId: 35915,
    plans: [
      {
        period: "Monthly",
        title: "Pro",
        price: 60,
        id: "12528",
        seats: 1,
        seatPrice: 60,
        active: true,
      },
      {
        period: "Annually",
        title: "Pro",
        price: 432,
        id: "73754",
        seats: 1,
        seatPrice: 432,
        active: true,
      },
      {
        period: "Annually",
        title: "Pro",
        price: 288,
        id: "79415",
        seats: 1,
        seatPrice: 288,
        earlyBird: true,
      },
      {
        period: "Annually",
        title: "Pro",
        price: 360,
        id: "73413",
        seats: 1,
        seatPrice: 360,
      },
      {
        period: "Annually",
        title: "Pro",
        price: 540,
        id: "13311",
        seats: 1,
        seatPrice: 540,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 50,
        id: "12527",
        seats: 1,
        seatPrice: 50,
        legacy: true,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 360,
        id: "13310",
        seats: 1,
        seatPrice: 360,
        legacy: true,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 40,
        id: "39729",
        seats: 1,
        seatPrice: 40,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 20,
        id: "78644",
        seats: 1,
        seatPrice: 20,
        active: true,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 360,
        id: "39730",
        seats: 1,
        seatPrice: 360,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 240,
        id: "73412",
        seats: 1,
        seatPrice: 240,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 288,
        id: "73755",
        seats: 1,
        seatPrice: 288,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 144,
        id: "78645",
        seats: 1,
        seatPrice: 144,
        active: true,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 96,
        id: "79414",
        seats: 1,
        seatPrice: 96,
        earlyBird: true,
      },
      {
        period: "Monthly",
        title: "Premium",
        price: 500,
        id: "13313",
        seats: 15,
        seatPrice: 500,
        active: true,
      },
      {
        period: "Annually",
        title: "Premium",
        price: 4800,
        id: "13314",
        seats: 15,
        seatPrice: 4800,
        active: true,
      },
    ]
  },
  appSumo: {
    plans: [
      {
        period: "Lifetime",
        title: "AppSumo License Tier 1 Lifetime plan",
        price: 69,
        id: "storydoc_tier1",
        seats: 1,
        seatPrice: 40,
      },
      {
        period: "Lifetime",
        title: "AppSumo License Tier 2 Lifetime plan",
        price: 149,
        id: "storydoc_tier2",
        seats: 5,
        seatPrice: 40,
      },
      {
        period: "Lifetime",
        title: "AppSumo License Tier 3 Lifetime plan",
        price: 309,
        id: "storydoc_tier3",
        seats: 15,
        seatPrice: 40,
      },
    ],
  },
  editorV4BaseUrl: "https://editor-bundle-staging.storydoc.com",
  betaEditorURL: "https://www.storydoc.com/assets/editor-bundle/staging",
  editorUrl: "https://app-staging.storydoc.com/",
  editorV4Url: "https://editor-staging.storydoc.com/",
  loginUrl: "https://editor-staging.storydoc.com/login",
};
